'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var EventIndex = /*#__PURE__*/function () {
  function EventIndex() {
    _classCallCheck(this, EventIndex);

    this._index = null;
  }

  _createClass(EventIndex, [{
    key: "get",
    value: function get() {
      return this._index ? this._index.values : [];
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(oplog) {
      this._index = oplog;
    }
  }]);

  return EventIndex;
}();

module.exports = EventIndex;